import type Member from 'iam/models/Member'
import { Env } from 'infra/env'
import { PostHogSessionRecordingService } from './PostHogSessionRecordingService'
import { NoOpSessionRecordingService } from './NoOpSessionRecordingService'

/**
 * Interface for session recording services.
 * Implementations handle user identification and session cleanup.
 */
export interface SessionRecordingService {
  // Links a user to the current session
  identify(member: Member): void
  // Clears session data (typically on logout)
  reset(): void
}

// Factory that returns PostHog if configured, otherwise a no-op fallback
export function createSessionRecordingService(): SessionRecordingService {
  return Env.POSTHOG_KEY
    ? PostHogSessionRecordingService.create()
    : NoOpSessionRecordingService.create()
}
